import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import metaDataReducer from './slices/metaDataSlice';

export const store = configureStore({
  reducer: {
    metaData: metaDataReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat()
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type StoreType = typeof store;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
